import React, { useContext } from 'react';
import { Newsletter } from '../../types/types';
import CheckboxRounded from '../../../components/react/checkbox_rounded/checkbox_rounded';
import { SignedInContext } from '../../context/signed_in_context';
import { UAContext } from '../../context/ua_context';

interface Props {
  isSignedIn: boolean;
  newsletter: Newsletter;
  onNewsletterToggle: () => Promise<Newsletter>;
}

const NewsletterBlock: React.FC<Props> = ({
  isSignedIn,
  newsletter,
  onNewsletterToggle,
}: Props) => {
  const { preselectedNewsletters, emailFromUrl } = useContext(
    isSignedIn ? SignedInContext : UAContext
  );

  return (
    <div
      data-testid='newsletter-block'
      className={`newsletter-block col-lg-5 col-12 ${newsletter.accent_color} border-bottom`}
    >
      <div className='pb-2 pt-3'>
        <div className='row'>
          <div className='col-10 col-lg-11'>
            <div className='frequency mb-1'>{newsletter.frequency}</div>
            <div className='mb-2 mt-1'>
              <h2 className='title fs-3 fw-bold mb-0'>
                <i
                  data-testid='newsletter-icon'
                  className={`icon fal icon-${newsletter.icon} me-2`}
                ></i>{' '}
                {newsletter.name}
              </h2>
            </div>
            <div className='mb-25'>{newsletter.description}</div>
            {newsletter.sample_url && (
              <div className='mb-25'>
                <a href={newsletter.sample_url} target='_blank' rel='noreferrer'>
                  View sample {'>'}
                </a>
              </div>
            )}
          </div>
          <div className='col-2 col-lg-1 text-end pt-4'>
            <CheckboxRounded
              dataTestId={`subscribe-button-${newsletter.permalink}`}
              onClickHandler={onNewsletterToggle}
              checked={
                isSignedIn || !!emailFromUrl
                  ? // The following assertion can only return true if user is signed in.
                // OR if user is not signed but an email was provided in the URL of the page.
                // For UAs without prefilled email, field `subscribed` is always remain `false`
                  newsletter.subscribed
                  : // The following assertion can only return true if user is UA and an email is
                // provided in URL. Signed in users and UAs with prefilled emails cannot
                // pre-select newsletter.
                  preselectedNewsletters.map((item) => item.id).includes(newsletter.id)
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsletterBlock;
